import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  InfoBlock,
  InfoBlockContainer,
  InfoElement,
  InfoWrapper,
  InfoWrapperTitle,
} from '../../open-questionnaires-details.styles';
import {
  PLATFORM_THEME_COLORS,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { getCorrectFormatEmployeeInfoField } from 'src/components/employee/employee-details.helpers';

import { generateReactKey } from 'src/common/helpers/common.helpers';

import { IEmployeePersonalInfo } from '../../../../../auth/sub-pages/questionnaire/questionnaire.interfaces';


interface IFile {
  location?: string;
  filename?: string;
}

const PersonalInfoQuestionnairesDetails = ({
  employeePersonalInfoData,
  personalIdCardFront,
  personalIdCardBack,
}: {
  employeePersonalInfoData: IEmployeePersonalInfo;
  personalIdCardFront?: IFile;
  personalIdCardBack?: IFile;
}) => {
  const { t } = useTranslation('employee');

  const {
    firstName,
    salutation,
    lastName,
    email,
    gender,
    birthName,
    cityOfBirth,
    countryOfBirth,
    personalEmail,
    street,
    houseNumber,
    country,
    city,
    zipCode,
    phoneNumber,
    nationality,
    birthday,
    status,
    accessToPlatform,
    employeeNumber,
    academicDegree,
    socials,
  } = employeePersonalInfoData;

  const firstColumn = {
    salutation,
    firstName,
    lastName,
    birthName,
    gender,
    academicDegree,
    employeeNumber,
    accessToPlatform,
    status
  };

  const secondColumn = {
    phoneNumber,
    email,
    personalEmail,
    birthday,
    cityOfBirth,
    countryOfBirth,
    nationality,
    linkedIn: socials?.linkedIn,
    xing: socials?.xing,
  };

  const thirdColumn = {
    street,
    houseNumber,
    country,
    city,
    zipCode,
    personalIdCardFront,
    personalIdCardBack,
  };

  const data = [firstColumn, secondColumn, thirdColumn];

  return (
    <InfoWrapper>
      <InfoWrapperTitle>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t(`employee:employeePersonalInfo.labels.personalInfo`)}
        </Typography>
      </InfoWrapperTitle>

      <InfoBlock>
        {data.map((el) => {
          return (
            <InfoBlockContainer key={generateReactKey()}>
              {Object.entries(el).map(([key, value]) => {
                return (
                  <InfoElement key={generateReactKey()}>
                    <Typography weight="bold">{`${t(
                      `employee:questionnaire.employeePersonalInfo.labels.${key}`
                    )}`}</Typography>
                    <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                      {getCorrectFormatEmployeeInfoField({ t, key, value }) || '-'}
                    </Typography>
                  </InfoElement>
                );
              })}
            </InfoBlockContainer>
          );
        })}
      </InfoBlock>
    </InfoWrapper>
  );
};

export default PersonalInfoQuestionnairesDetails;
